import { render, staticRenderFns } from "./head_img.vue?vue&type=template&id=d2986682&scoped=true"
import script from "./head_img.vue?vue&type=script&lang=js"
export * from "./head_img.vue?vue&type=script&lang=js"
import style0 from "./head_img.vue?vue&type=style&index=0&id=d2986682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2986682",
  null
  
)

export default component.exports